var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8417 14.0922C15.5952 14.0922 18.6331 11.1483 18.6331 7.51094C18.6331 3.87362 15.5952 0.929688 11.8417 0.929688C8.08821 0.929688 5.05025 3.87362 5.05025 7.51094C5.05025 11.1483 8.08821 14.0922 11.8417 14.0922ZM16.4987 15.9726H15.9954C14.7341 16.5602 13.3334 16.9127 11.8417 16.9127C10.35 16.9127 8.95533 16.5602 7.688 15.9726H7.18471C3.32814 15.9726 0.199219 19.0046 0.199219 22.7418V24.4342C0.199219 25.9913 1.50293 27.2547 3.10984 27.2547H20.5736C22.1805 27.2547 23.4842 25.9913 23.4842 24.4342V22.7418C23.4842 19.0046 20.3553 15.9726 16.4987 15.9726ZM29.3054 14.0922C32.5192 14.0922 35.1267 11.5655 35.1267 8.45112C35.1267 5.33678 32.5192 2.81005 29.3054 2.81005C26.0916 2.81005 23.4842 5.33678 23.4842 8.45112C23.4842 11.5655 26.0916 14.0922 29.3054 14.0922ZM32.216 15.9726H31.9856C31.1427 16.2546 30.2514 16.4426 29.3054 16.4426C28.3595 16.4426 27.4681 16.2546 26.6252 15.9726H26.3948C25.1578 15.9726 24.0178 16.3192 23.0173 16.8775C24.4968 18.4229 25.4246 20.4737 25.4246 22.7418V24.9983C25.4246 25.1276 25.3943 25.251 25.3882 25.3744H36.0969C37.7038 25.3744 39.0075 24.111 39.0075 22.5538C39.0075 18.9165 35.9695 15.9726 32.216 15.9726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.4c89829f4fb7f3a9d066baf5dd88583c.svg";
export { ForwardRef as ReactComponent };